<template>
  <div class="flex -mx-3">
    <div class="w-64 px-4">
      <img v-if="page.cover" :src="page.cover" class="w-full border rounded" />
      <div v-else class="aspect-ratio-16/9 border rounded w-full bg-gray-200" />
    </div>
    <div class="flex-1 px-3 space-y-1">
      <p>
        <slot>
          <p>{{ page.title }}</p>
        </slot>
      </p>
      <a
        :href="page.url"
        target="_blank"
        class="inline-block text-gray-600 text-sm no-underline hover:underline"
        >{{ page.url }}</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'DataIteratItem',
  props: {
    page: {
      type: Object,
      required: true,
    },
  },
};
</script>
